

















import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class CoinsIcon extends Vue {
  @Prop({ default: '21' }) readonly width?: string;
  @Prop({ default: '24' }) readonly height?: string;
  @Prop({ default: '#10222D' }) readonly fill?: string;
}
